import { render } from "./AiModelsCarousel.vue?vue&type=template&id=15dbb9f7&scoped=true"
import script from "./AiModelsCarousel.vue?vue&type=script&lang=js"
export * from "./AiModelsCarousel.vue?vue&type=script&lang=js"

import "./AiModelsCarousel.vue?vue&type=style&index=0&id=15dbb9f7&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15dbb9f7"],['__file',"src/Components/ChatWidget/AssistantAi/AiComponents/AiModelsCarousel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15dbb9f7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15dbb9f7', __exports__)) {
    api.reload('15dbb9f7', __exports__)
  }
  
  module.hot.accept("./AiModelsCarousel.vue?vue&type=template&id=15dbb9f7&scoped=true", () => {
    api.rerender('15dbb9f7', render)
  })

}


export default __exports__